import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { parse, format, AsYouType } from 'libphonenumber-js';
import { EventsService } from 'angular4-events';
declare var Nanobar: any;

declare var $: any;
declare var toastr: any;
declare var google: any;

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.css']
})
export class DriversComponent implements OnInit {
  nao = new Nanobar();
  driverData: any;
  paginatedData: any;
  rejectId: any;
  page = 0;
  last_page = true;
  once = false;
  paging_once = false;
  paging = false;
  pushReceive: any;
  limit: any;
  acceptId: any;
  btnShowAfterLoad = false;
  searchDriver = '';
  clearTimeout: any;
  filterValue = 'All';
  filterValCount = 0;
  noDataFoundSearch = false;
  type = 'data';
  defaultViewToShow = false;
  constructor(private dataService: DataService, private pubsub: EventsService, private events: EventsService) {
    this.dataService.pageName = 'driver listing';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
    this.events.subscribe('driverDetailUpdateDone').subscribe((data) => {
      if (data.page === 'drivers') {
        $('.driverDetail').css('display', 'none');
        setTimeout(() => {
          $('.driverListing').css('display', 'block');
          $('html').scrollTop(data.scroll);
        });
      }
    });
  }
  clearSearch() {
    this.searchDriver = '';
    this.filterSearch();
  }

  driverlist() {
    this.last_page = true;
    this.nao.go(30);
    this.noDataFoundSearch = false;
    this.btnShowAfterLoad = false;
    this.type = 'data';
    this.driverData = [];
    console.log('login data');
    this.dataService.getDriverList(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        console.log('customer data', data);
        this.driverData = data;
        if (this.driverData.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.driverData.rest_error_code === 2) toastr.error('Please login again');
        if (this.driverData.rest_error_code === 4) toastr.error('Doest not exist');
        this.limit = 2;
        this.last_page = this.driverData.last_page;
        this.page++;
        this.driverData = this.driverData.items;
        if (this.driverData.length === 0) {
          this.defaultViewToShow = true;
        }
        this.btnShowAfterLoad = true;
        for (var i = 0; i < this.driverData.length; i++) {
          if (this.driverData[i].country_code === '+1') {
            this.driverData[i].phone_number = format(this.driverData[i].phone_number, 'US', 'NATIONAL');
            console.log('this.driverData[i].number', this.driverData[i].phone_number);
          }
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  acceptDriverFunction(id) {
    this.nao.go(30);
    console.log('login data');
    this.dataService.acceptDriver(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        // this.driverlist();
        for (var i = 0; i < this.driverData.length; i++) {
          if (id === this.driverData[i].id) {
            console.log(id, this.driverData[i].id);
            this.driverData[i].status = 1;
            console.log('this.driverData', this.driverData);
          }
        }
        $('#acceptDriverPop').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  acceptDriverPopOpen(id) {
    this.acceptId = id;
    $('#acceptDriverPop').modal('show');
  }
  rejectDriverFunction(id) {
    this.rejectId = id;
    $('#rejectDriverpop').modal('show');
  }
  rejectDriverpopOpen(id) {
    this.nao.go(30);
    console.log('login data');
    this.dataService.rejectDriver(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        // this.driverlist();
        for (var i = 0; i < this.driverData.length; i++) {
          if (id === this.driverData[i].id) {
            console.log(id, this.driverData[i].id);
            this.driverData[i].status = 2;
            console.log('this.driverData', this.driverData);
          }
        }
        $('#rejectDriverpop').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  inputAddress1() {
    console.log('inputAddress');

    const input = document.getElementById('searchTextField');

    const searchBox = new google.maps.places.Autocomplete(input);
    searchBox.addListener('place_changed', function () {

      console.log('place changed');
      const place = searchBox.getPlace();
      console.log('address', place);

    });
  }
  inputAddress2() {

    const input2 = document.getElementById('searchTextField2');

    const searchBox2 = new google.maps.places.Autocomplete(input2);
    searchBox2.addListener('place_changed', function () {

      console.log('place changed');
      const place = searchBox2.getPlace();
      console.log('address', place);

    });
  }
  getDriverListByPageFunction() {
    this.last_page = true;
    this.nao.go(30);
    console.log('login data');
    this.dataService.getDriverListByPage(window.localStorage.getItem('token'), this.page).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedData = data;
        // this.limit = this.paginatedData.limit;
        this.last_page = this.paginatedData.last_page;
        this.paginatedData = this.paginatedData.items;
        for (var i = 0; i < this.paginatedData.length; i++) {
          if (this.paginatedData[i].country_code === '+1') {
            this.paginatedData[i].phone_number = format(this.paginatedData[i].phone_number, 'US', 'NATIONAL');
            console.log('this.driverData[i].number', this.paginatedData[i].phone_number);
          }
        }
        console.log('paginated before concat data', this.paginatedData);
        this.page++;
        // this.paging = false;
        // this.once = false;
        // this.paging_once = false;
        for (var i = 0; i < this.paginatedData.length; i++) {
          this.driverData.push(this.paginatedData[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  filterValUpdate(val) {
    this.filterValue = val;
    if (val === 'All') {
      this.filterValCount = 0;
      this.filterSearch();
    }
    if (val === 'Online') {
      this.filterValCount = 1;
      this.filterSearch();
    }
    if (val === 'Offline') {
      this.filterValCount = 2;
      this.filterSearch();
    }
    if (val === 'Pending') {
      this.filterValCount = 3;
      this.filterSearch();
    }
    if (val === 'Approved') {
      this.filterValCount = 4;
      this.filterSearch();
    }
  }
  filterSearch() {
    this.last_page = true;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.type = 'search';
      this.driverData = [];
      this.page = 0;
      this.btnShowAfterLoad = false;
      // if (this.searchDriver === '') {
      //   this.driverlist();
      //   return;
      // }
      this.nao.go(30);
      console.log('login data');
      this.dataService.searchDriverWithFilter(window.localStorage.getItem('token'), this.searchDriver, this.filterValCount).subscribe(
        (data) => {
          this.nao.go(100);
          this.driverData = data;
          this.last_page = this.driverData.last_page;
          this.page++;
          this.driverData = this.driverData.items;
          for (var i = 0; i < this.driverData.length; i++) {
            if (this.driverData[i].country_code === '+1') {
              this.driverData[i].phone_number = format(this.driverData[i].phone_number, 'US', 'NATIONAL');
              console.log('this.driverData[i].number', this.driverData[i].phone_number);
            }
          }
          this.btnShowAfterLoad = true;
          if (this.driverData.length === 0) {
            this.noDataFoundSearch = true;
          }
        },
        (error) => {
          this.nao.go(100);
          console.log('error', error);
        }
      );
    }, 1000);
  }
  getDriversDetail(id) {
    var scroll = $(window).scrollTop();
    var data = { 'id': id, 'page': 'drivers', 'scroll': scroll };
    this.events.publish('driversListing', data);
    $('.driverListing').css('display', 'none');
    setTimeout(() => {
      $('.driverDetail').css('display', 'block');
      $('html').scrollTop(0);
    });
  }
  ngOnInit() {
    $('.driverDetail').css('display', 'none');
    var context = this;
    this.inputAddress1();
    this.inputAddress2();
    this.driverlist();
    this.pushReceive = this.pubsub.subscribe('detectChange').subscribe((data) => {
      console.log('push data new_customer', data);
      if (data === 'new_driver') {
        this.driverlist();
      }
    });
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#driver').css('color', '#d77229');
    // $(window).scroll(function () {
    //   if (context.dataService.pageName === 'driver listing') {
    //     if (parseInt($(window).scrollTop()) + parseInt($(window).height()) > parseInt($(document).height()) - 10) {
    //       if (context.last_page !== true) {
    //         context.paging = true;
    //         if (!context.paging_once) {
    //           context.paging_once = true;
    //           context.getDriverListByPageFunction();
    //         }
    //       }
    //     } else {
    //       if (context.once) {
    //         context.paging = false;
    //         context.once = true;
    //       }
    //     }
    //   }
    //  });
  }

}



// WEBPACK FOOTER //
// ./src/app/drivers/drivers.component.ts